module.exports = __webpack_public_path__ + "icon-print.svg?76478c16f23df7eb6c8f646ad393f2e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iam-icons/icon-print.svg
// module id = 18
// module chunks = 0